import {
  GET_CIVILMATERIALACOUNT,
  GET_CIVILMATERIALACOUNT_SUCCESS,
  GET_CIVILMATERIALACOUNT_FAIL,
  DELETE_CIVILMATERIALACOUNT,
  DELETE_CIVILMATERIALACOUNT_SUCCESS,
  DELETE_CIVILMATERIALACOUNT_FAIL,
  UPDATE_CIVILMATERIALACOUNT,
  UPDATE_CIVILMATERIALACOUNT_SUCCESS,
  UPDATE_CIVILMATERIALACOUNT_FAIL,
  ADD_NEW_CIVILMATERIALACOUNT,
  ADD_CIVILMATERIALACOUNT_SUCCESS,
  ADD_CIVILMATERIALACOUNT_FAIL,
  CIVILMATERIALACOUNT_LOADING,
  CIVILMATERIALACOUNT_RESET
} from "./actionType";

export const resetCivilAccountState = (actionType) => ({
  type: CIVILMATERIALACOUNT_RESET,
  payload: { actionType },
});

export const getCivilAccountSuccess = (actionType, data) => ({
  type: GET_CIVILMATERIALACOUNT_SUCCESS,
  payload: { actionType, data },
});

export const getCivilAccountFail = (actionType, error) => ({
  type: GET_CIVILMATERIALACOUNT_FAIL,
  payload: { actionType, error },
});

export const getCivilAccount = data => ({
  type: GET_CIVILMATERIALACOUNT,
  payload: data,
});

export const getCivilAccountLoading = () => ({
  type: CIVILMATERIALACOUNT_LOADING
});

export const deleteCivilAccount = data => ({
  type: DELETE_CIVILMATERIALACOUNT,
  payload: data,
});

export const deleteCivilAccountSuccess = data => ({
  type: DELETE_CIVILMATERIALACOUNT_SUCCESS,
  payload: data,
});

export const deleteCivilAccountFail = error => ({
  type: DELETE_CIVILMATERIALACOUNT_FAIL,
  payload: error,
});

export const updateCivilAccount = data => ({
  type: UPDATE_CIVILMATERIALACOUNT,
  payload: data,
});

export const updateCivilAccountFail = error => ({
  type: UPDATE_CIVILMATERIALACOUNT_FAIL,
  payload: error,
});

export const updateCivilAccountSuccess = data => ({
  type: UPDATE_CIVILMATERIALACOUNT_SUCCESS,
  payload: data,
});

export const addNewCivilAccount = data => ({
  type: ADD_NEW_CIVILMATERIALACOUNT,
  payload: data,
});

export const addCivilAccountSuccess = data => ({
  type: ADD_CIVILMATERIALACOUNT_SUCCESS,
  payload: data,
});

export const addCivilAccountFail = error => ({
  type: ADD_CIVILMATERIALACOUNT_FAIL,
  payload: error,
});